import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { GetImplementationPeriodList } from "../../../../Redux/Reducers/Submitter/ImplementationPeriod";
import {
  GetBI_TimelineInformation,
  SetBI_TimelineInformation,
  UpdateTimeFrameInformation,
} from "../../../../Redux/Reducers/Submitter/TimeFrameInformation";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import DateInput from "../../../../Components/DateInput";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import "./style.css";
import loadConfig from "../../../../Services/Api/ApiServices";

const TimeFrameInformation = (props) => {
  const AppGuid = useParams();
  const validationListValidation = useSelector(
    (state) => state.BudgetItemsRequestedFromSomanReducers.Validation
  );

  const EditBI_TimelineInformation_ = useSelector(
    (state) => state.TimeFrameInformationReducers.UpdateTimeFrameInformation
  );
  const LodingBI_TimelineInformation_ = useSelector(
    (state) => state.TimeFrameInformationReducers.loadingTimeFrameInformation
  );
  const [ProposedStartDateDefault, setProposedStartDateDefault] =
    useState(null);
  const [ImplementationPeriod, setImplementationPeriod] = useState(null);
  const [validationStatus, setValidationStatus] = useState(false);
  const [proposedStartDate, setProposedStartDate] = useState("");
  const [
    bI_ImplementationDurationMonthsId,
    setBI_ImplementationDurationMonthsId,
  ] = useState("");
  const [expectedEndDate, setExpectedEndDate] = useState();
  const [changeTimeMonthes, setchangeTimeMonthes] = useState(false);
  const [dataJsonObject, SetDataJsonObject] = useState();

  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      BI_TimelineInformation:
        state.TimeFrameInformationReducers.TimeFrameInformation,
      BI_TimelineInformationLoding:
        state.TimeFrameInformationReducers.loadingTimeFrameInformation,
      bI_ImplementationDurationMonths:
        state.ImplementationPeriod.ImplementationPeriod,
      //   ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
    };
  });
  const validationList = useSelector(
    (state) => state.ValidationBudget?.ValidationBudgetList
  );

  const [BI_TimelineInformationData, setBI_TimelineInformationData] = useState({
    ...state.BI_TimelineInformation,
  });
  //to assigin data in felds
  useEffect(() => {
    setProposedStartDateDefault(
      state.BI_TimelineInformation?.proposedStartDate
    );
    setImplementationPeriod(
      state.BI_TimelineInformation?.bI_ImplementationDurationMonthsId
    );
  }, [state.BI_TimelineInformation]);
  // Fetch initial data for implementation duration and timeline information
  useEffect(() => {
    dispatch(GetImplementationPeriodList()); // Fetch all possible implementation duration options
    dispatch(
      GetBI_TimelineInformation(
        localStorage.getItem("ApplicationInformationId") ||
          props.applicationGuid // Retrieve application ID from localStorage or decrypt token
      )
    );
  }, [EditBI_TimelineInformation_, changeTimeMonthes]); // Runs when either `EditBI_TimelineInformation_` or `changeTimeMonthes` changes

  // Update local state with timeline information when loading completes
  useEffect(() => {
    if (!state.BI_TimelineInformationLoding) {
      // Check if timeline information is done loading
      setBI_TimelineInformationData({ ...state.BI_TimelineInformation }); // Set the data in local state
    }
  }, [state.BI_TimelineInformationLoding]); // Runs whenever loading state changes

  // Update global state with local timeline information changes
  useEffect(() => {
    dispatch(SetBI_TimelineInformation({ ...BI_TimelineInformationData })); // Dispatch updated timeline information to global state
  }, [BI_TimelineInformationData]); // Runs whenever local timeline information data changes
  //to show confirmation popup on monthes change to handel and edit if confirmed
  const DurationMonthChange = (e) => {
    Swal.fire({
      title: "  تنبيه",
      text: "هل انت متأكد من التعديل على مدة التنفيذ؟ في حال تأكيد التعديل سيتم حذف الشهور الإضافية من توزيع مساهمة شومان في موازنة التكاليف وسيتطلب إعادة التوزيع لكل بند على حدا",
      confirmButtonText: "تأكيد",
      cancelButtonText: "الغاء",
      showCancelButton: true,
      showCloseButton: true,
      customClass: {
        confirmButton: "sweetalertBtn",
        cancelButton: "closeBtnSweet",
      },
    }).then(async (res) => {
      //if confirmed it will change value on dropdown
      if (res.isConfirmed == true) {
        setBI_ImplementationDurationMonthsId(parseInt(e.target.value));
        dispatch(
          UpdateTimeFrameInformation({
            bI_TimelineInformationId:
              state.BI_TimelineInformation?.timeFrameInformationId,
            proposedStartDate: state.BI_TimelineInformation?.proposedStartDate,
            bI_ImplementationDurationMonthsId: parseInt(e.target.value),
            expectedEndDate: state.BI_TimelineInformation?.expectedEndDate,
            aI_ApplicationInformationId: localStorage.getItem(
              "ApplicationInformationId"
            ),
          })
        );
        //if isDismissed it will do nothing
      } else if (res.isDismissed == true) {
        setBI_ImplementationDurationMonthsId(
          state.BI_TimelineInformation?.bI_ImplementationDurationMonthsId
        );
        if (!changeTimeMonthes) {
          setchangeTimeMonthes(true);
        } else {
          setchangeTimeMonthes(false);
        }
      }
    });
  };
  console.log(state.BI_TimelineInformation, "maswswsdededwswslek");

  const validation = () => {};

  let validationList2 =
    validationListValidation &&
    validationListValidation.map((ele) => {
      return ele.code;
    });
  //after loding ends render html
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);

  return !LodingBI_TimelineInformation_ && dataJsonObject ? (
    <>
      <p className="massage">{dataJsonObject.StartDataMassage}</p>
      <div className="form-grid">
        <div>
          <DateInput
            disabled={props.shouldDisableFields}
            fieldsName="ProposedStartDate"
            date={state.BI_TimelineInformation?.proposedStartDate}
            // showMassage={true}
            // massage={"dsfdsdsfdfdsffdsfddfdfsdsf sdfsdfssssssssssssssss"}
            onChange={(e) => {
              const adjustedDate = new Date(
                Date.UTC(e.getFullYear(), e.getMonth(), e.getDate())
              );
              console.log(adjustedDate, "dwdwdwdwdwdwd");

              setProposedStartDate(adjustedDate);

              setBI_TimelineInformationData({
                ...BI_TimelineInformationData,
                proposedStartDate: adjustedDate,
              });
              setProposedStartDateDefault(adjustedDate);
              if (state.BI_TimelineInformation?.implementationPeriodId) {
                dispatch(
                  UpdateTimeFrameInformation({
                    bI_TimelineInformationId:
                      state.BI_TimelineInformation?.timeFrameInformationId,
                    proposedStartDate: adjustedDate,
                    bI_ImplementationDurationMonthsId:
                      state.BI_TimelineInformation?.implementationPeriodId,
                    expectedEndDate:
                      state.BI_TimelineInformation?.expectedEndDate,
                    aI_ApplicationInformationId: localStorage.getItem(
                      "ApplicationInformationId"
                    ),
                  })
                );
              }
            }}
            minDate={new Date(2025, 0, 1)}
            showValidationMessage={
              validationList2 && validationList2.includes("ProposedStartDate")
            }
            validationMessage="يرجى تعبئة هذا الحقل"
            filterDate={true}
          />
        </div>
        <AllDropDownsAHSF
          fieldsName="ImplementationPeriod"
          show={true}
          disabled={props.shouldDisableFields}
          dropdownType="normal"
          arrayOoptionList={state.bI_ImplementationDurationMonths}
          KeyText={"implementationPeriod"}
          KeyValue={"implementationPeriodId"}
          defaultValue={state.BI_TimelineInformation?.implementationPeriodId}
          onChange={(e) => {
            validationList2 = [];
            setImplementationPeriod(e);
            setBI_ImplementationDurationMonthsId(parseInt(e.target.value));
            dispatch(
              UpdateTimeFrameInformation({
                bI_TimelineInformationId:
                  state.BI_TimelineInformation?.timeFrameInformationId,
                proposedStartDate:
                  state.BI_TimelineInformation?.proposedStartDate,
                bI_ImplementationDurationMonthsId: parseInt(e.target.value),
                expectedEndDate: state.BI_TimelineInformation?.expectedEndDate,
                aI_ApplicationInformationId: localStorage.getItem(
                  "ApplicationInformationId"
                ),
              })
            );
          }}
          showValidationMessage={
            validationList2 && validationList2.includes("ImplementationPeriod")
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <DateInput
          fieldsName="ExpectedEndDate"
          list=""
          date={state.BI_TimelineInformation?.expectedEndDate}
          disabled={true}
          onChange={(e) => {
            validationList2 = [];

            setExpectedEndDate(e);
            dispatch(
              UpdateTimeFrameInformation({
                bI_TimelineInformationId:
                  state.BI_TimelineInformation?.bI_TimelineInformationId,
                proposedStartDate:
                  state.BI_TimelineInformation?.proposedStartDate,
                bI_ImplementationDurationMonthsId:
                  state.BI_TimelineInformation
                    ?.bI_ImplementationDurationMonthsId,
                expectedEndDate: e,
                aI_ApplicationInformationId: localStorage.getItem(
                  "aI_ApplicationInformationId"
                ),
              })
            );
          }}
        />
      </div>
    </>
  ) : (
    ""
  );
};

export default TimeFrameInformation;
